import React from 'react';

const Home = () => {
  return (
    <div><h2>Not Found</h2></div>
  )
}

export default Home;
